module.exports = __webpack_public_path__ + "static/19-4d71a6b46dc45561479534c298216acf.jpg";